import React, { useCallback, useEffect, useMemo, useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "../../../assets/css/Excursion.css";
import {
  ChevronDownIcon,
  TimeIcon,
  TickIcon,
  InstantIcon,
  CloseIcon,
  MealIcon,
  CarIcon,
  UserIcon,
  EmtyImageIcon,
  ChevronLeftIcon,
  InstantIconNew,
} from "../../../helper/HwIconExcursion";
import { ChevronUpIcon, InfoIcon, UserGroupIcon, ZoomIcon, ExcursionSeatIcon } from "../../../helper/HwIcon";
import { getExcurstionDetails } from "./getExcurstionDetails";
import { PersonsInfoModal } from "./components/PersonsInfoModal";
import HwDatePicker from "../../../component/HwDatePicker";
import CommonPopup from "../../common-popup/CommonPopup";
import WarningPopUp from "../../common-popup/WarningPopup";
import { VariationSlider } from "./components/VariationSlider";
import { ToggleItems } from "./components/ToggleItems";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const ExcursionDetails = () => {
  const navigate = useNavigate();
  const myFullscreenButton = (onClick, isFullscreen) => (
    <button
      type="button"
      className="image-gallery-icon image-gallery-fullscreen-button"
      onClick={onClick}
      aria-label="Toggle Fullscreen"
    >
      <ZoomIcon/>
    </button>
  );

  const nextValidDate = (startDate, blackoutDates = [], blackoutDays = []) => {
    if (!startDate) return null;
    const blackoutDaysLower = (Array.isArray(blackoutDays) ? blackoutDays : [])
      .map((d) => String(d).toLowerCase());
    if (blackoutDaysLower.length >= 7) return null;

    let date = moment(startDate);
    const normalizedBlackoutDates = Array.isArray(blackoutDates) ? blackoutDates : [];
    const maxDaysToCheck = 366;
    for (let i = 0; i < maxDaysToCheck; i++) {
      const isBlackoutDate = normalizedBlackoutDates.some((d) =>
        moment(d, ["YYYY/MM/DD", "YYYY-MM-DD"]).isSame(date, "day")
      );
      const isBlackoutDay = blackoutDaysLower.includes(date.format("dddd").toLowerCase());
      if (!isBlackoutDate && !isBlackoutDay) {
        return date.toDate();
      }
      date.add(1, "day");
    }
    return null;
  };

  const {
    data,
    personsInfoModal,
    setPersonsInfoModal,
    showTypeDropdown,
    setShowTypeDropdown,
    showModal,
    setShowModal,
    loading: detailsLoading,
    showVariations,
    setShowVariations,
    getAvailability,
    resolvePricesForDate,
    checkAvailability,
    availability,
    raiseInquiry,inquiry,setInquiry,
    createCheckoutSession , checkoutLoading
  } = getExcurstionDetails();

  let customTimeSlots = data?.customProductTimeSlots || []

  const blackOutDays = Array.isArray(data?.singleExcursionData?.excursion_blackout_by_day)
    ? data.singleExcursionData.excursion_blackout_by_day
    : [];

  const blackoutDates = Array.isArray(data?.singleExcursionData?.blackout_excursion_tour_date)
    ? data?.singleExcursionData?.blackout_excursion_tour_date.map(d => d?.excursion_blackout_date)
    : [];


  const [fieldValue, setFieldValue] = useState({
    selectDate: null,
    time: "",
    transfer: "without-transfer",
    numberOfAdults: 1,
    numberOfChild: 0,
    numberOfInfants: 0,
  });

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  useEffect(()=>{
    if(inquiry?.message){
      const timer = setTimeout(()=>{
        setInquiry({})
      },3000)
      return ()=> clearTimeout(timer)
    }
  },[inquiry])

  useEffect(() => {
    setInquiry({})
    const fetchAvailability = async () => {
      if(customTimeSlots?.length > 0){
        return;
      }
      if ((data?.bookedAsPerTheCsvExpiryDate && data?.bulkTicketInventorySystem) || data?.customProductTimeSlotBase) {
        await getAvailability(
          data?.singleId,
          moment(fieldValue.selectDate).format("YYYY-MM-DD"),
          fieldValue?.numberOfChild,
          fieldValue?.numberOfAdults
        );
      }
    };

    fetchAvailability();
  }, [fieldValue?.selectDate,fieldValue?.numberOfChild,fieldValue?.numberOfAdults,fieldValue?.numberOfInfants]);

  useEffect(() => {
    // Initialise the selected date only once, when the detail first loads.
    // Re-running on every `data` change (e.g. after a price re-resolve) would
    // reset the user's chosen date back to today.
    if (data && !Array.isArray(data) && data?.singleId) {
      const blackOutDays = Array.isArray(data?.singleExcursionData?.excursion_blackout_by_day)
      ? data.singleExcursionData.excursion_blackout_by_day
      : [];
      const blackoutDates = Array.isArray(data?.singleExcursionData?.blackout_excursion_tour_date)
      ? data?.singleExcursionData?.blackout_excursion_tour_date.map(d => d?.excursion_blackout_date)
      : [];

      const travelDateParam = new URLSearchParams(location.search).get("travel-date");
      const parsedTravelDate = moment(travelDateParam, "DD-MM-YYYY", true);
      const startDate =
        parsedTravelDate.isValid() && !parsedTravelDate.isBefore(moment(), "day")
          ? parsedTravelDate.toDate()
          : new Date();

      setFieldValue(prev => {
        if (prev?.selectDate) return prev; // keep the user's chosen date
        return { ...prev, selectDate: nextValidDate(startDate, blackoutDates, blackOutDays) };
      });
    }
  }, [data]);


  const [dummyLoading, setDummyLoading] = useState(false);
  const [availabilityMessage,setAvailabilityMessage]=useState("")
  const [isTicketAvailable, setIsTicketAvailable] = useState(true);
  const [activeTab, setActiveTab] = useState('excursion_ticket_highlights');
  const isDahrTours = data?.isDahrTours;
  const isHelidubai = data?.isHelidubai;
  const isDubaiPark = data?.isDubaiPark;
  const isRayna = data?.isRayna || data?.vendor === "rayna";
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const availableAdultSeat = data?.availableAdultSeat;
  const availableChildSeat = data?.availableChildSeat;

  const linePersons = useMemo(() => {
    return `${fieldValue.numberOfAdults} Adults, ${
      fieldValue.numberOfChild
    } Child${
      !isDahrTours && !isHelidubai && !isDubaiPark && !isRayna
        ? `, ${fieldValue.numberOfInfants} Infants`
        : ""
    }`;
  }, [
    fieldValue.numberOfAdults,
    fieldValue.numberOfChild,
    fieldValue.numberOfInfants,
    isDahrTours,
    isHelidubai,
    isDubaiPark,
    isRayna
  ]);

  useEffect(() => {
    if (isRayna) {
      setFieldValue((prev) => (prev?.numberOfInfants ? { ...prev, numberOfInfants: 0 } : prev));
    }
  }, [isRayna]);

  const renderVideo = useCallback((url) => {
    return (
      <div>
        <video muted autoPlay loop className="image-gallery-image">
          <source src={url} type="video/mp4" />
        </video>
      </div>
    );
  }, []);

  const images = (
    data?.singleExcursionGallery?.length > 0
      ? data?.singleExcursionGallery
      : [
          {
            url: data?.singleThumbnail,
            thumbnail: data?.singleThumbnail,
          },
        ]
  )?.map((d) => {
    let renderItem;
    if (d?.type === "video") {
      renderItem = () => renderVideo(d?.url);
    }
    return {
      original: d?.url,
      thumbnail: d?.thumbnail ?? d?.sizes?.thumbnail,
      renderItem,
    };
  });
  const onlyImages = images?.filter((d) => d?.type !== "video");
  const personLine = "";

  const scrollToDiv = (id) => {
    setActiveTab(id);
    const elem = document.getElementById(id);
    elem.style.scrollMarginTop = "180px";
    elem.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  if (detailsLoading) {
    return (
      <div
        className={`hw-widget hw-widget--excursion hw-widget--excursionDetails`}
      >
        <div className="hw-excursion--list">
          <div className="row">
            <div className="col-6">
              <Skeleton
                width={"35.5vw"}
                height={"350px"}
                count={1}
                style={{ marginRight: 12 }}
              />
            </div>
            <div className="col-6">
              <Skeleton width={"34.5vw"} height={"110px"} count={1} />
              <Skeleton width={"34.5vw"} height={"110px"} count={1} />
              <Skeleton width={"34.5vw"} height={"110px"} count={1} />
            </div>
          </div>
          <div className="row">
            <Skeleton
              width={"22vw"}
              height={"40px"}
              count={3}
              inline
              style={{ marginRight: 8 }}
            />
          </div>
          <div className="row">
            <div className="col-md-12">
              <Skeleton width={"72vw"} height={"300px"} count={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const showInfoIcon =
    data?.singleExcursionData?.timing_and_duration?.length > 0 ||
    data?.singleExcursionData?.info_booking_confirmation ||
    data?.singleExcursionData?.info_cancellation;

  const totalSelectedTicketCount =
    fieldValue.numberOfAdults +
    fieldValue.numberOfChild +
    fieldValue.numberOfInfants;

  const isAvailableTicketLessThanSelected = fieldValue?.time?.Available
    ? fieldValue?.time?.Available < totalSelectedTicketCount
    : false;

  const pricingObj = btoa(
    encodeURIComponent(JSON.stringify(data?.excursionTaxPricing ?? {}))
  );
  const taxObj = btoa(
    encodeURIComponent(JSON.stringify({
       vatRateType : data?.vatRateType , exclusiveOrInclusive : data?.exclusiveOrInclusive
    }))
  );


  return (
    <>
      <div
        className={`hw-widget hw-widget--excursionDetails`}
        onClick={() => {
          setPersonsInfoModal(false);
        }}
      >
        <div className="hw-page--width">
        <div className="mb-2 hw-mt--20">
          <button
            className="hw-link hw-link--gray700 hw-link--icon"
            onClick={() => {
              // Preserve the search context (city / country / date) the user
              // came from, so Back to Search returns to the same list.
              const sp = new URLSearchParams(window.location.search);
              const listParams = new URLSearchParams();
              const city = sp.get("city");
              const cityId = sp.get("city-id");
              const countryId = sp.get("country-id");
              let travelDate = sp.get("travel-date");
              if (!travelDate && fieldValue?.selectDate) {
                travelDate = moment(fieldValue.selectDate).format("DD-MM-YYYY");
              }
              if (city) listParams.set("city", city);
              if (cityId) listParams.set("city-id", cityId);
              if (countryId) listParams.set("country-id", countryId);
              if (travelDate) listParams.set("travel-date", travelDate);
              const q = listParams.toString();
              navigate(q ? `/excursion/list?${q}` : "/excursion/list");
            }}
          >
            <ChevronLeftIcon />
            Back to Search
          </button>
        </div>
        <CommonPopup
          show={showModal}
          title={data?.singleTitle}
          setShow={(_show) => {
            setShowModal(_show);
          }}
          headerClass={"hw-modal-headerExcursion"}
        >
          {data?.singleExcursionData?.timing_and_duration?.length > 0 ? (
            <div className="hw-excursion--modalBlock">
              <div className="hw-excursion--listInfoList">
                <span className="icon">
                  <TimeIcon />
                </span>
                Timing & Duration
              </div>
              <table className="hw-excursion--modalTable">
                <thead>
                  <tr>
                    <th>Transfer Type</th>
                    <th>Pickup Timings</th>
                    <th>Duration Approx</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.singleExcursionData?.timing_and_duration?.map?.(
                    (t) => {
                      return (
                        <tr>
                          <td>{t?.transfer_type}</td>
                          <td>
                            <p>{t?.pickup}</p>
                          </td>
                          <td>{t?.duration_approx}</td>
                        </tr>
                      );
                    }
                  ) || "-"}
                </tbody>
              </table>
            </div>
          ) : null}
          {data?.singleExcursionData?.info_booking_confirmation ? (
            <div className="hw-excursion--modalBlock">
              <div className="hw-excursion--listInfoList">
                <span className="icon">
                  <TickIcon />
                </span>
                Booking Confirmation
              </div>
              <div className="hw-excursion--listInfoText">
                {data?.singleExcursionData?.info_booking_confirmation ?? "-"}
              </div>
            </div>
          ) : null}
          {data?.singleExcursionData?.info_cancellation ? (
            <div className="hw-excursion--modalBlock">
              <div className="hw-excursion--listInfoList">
                <span className="icon">
                  <CloseIcon />
                </span>
                Cancellation
              </div>
              <div className="hw-excursion--listInfoText">
                {data?.singleExcursionData?.info_cancellation ?? "-"}
              </div>
            </div>
          ) : null}
        </CommonPopup>
        <WarningPopUp
          show={showWarningPopup}
          setShow={setShowWarningPopup}
        >
          <div className="warning-body">
              <button
                onClick={() => {
                  setShowWarningPopup(false);
                }}
                className=" warning-modal--close"
              >
                <CloseIcon />
              </button>
            <h3 className="warning-modal-title">Raise an Enquiry</h3>
            <p>{`Are you sure you want to raise an enquiry  for ${Number(fieldValue?.numberOfAdults + fieldValue?.numberOfChild + fieldValue?.numberOfInfants)} tickets on ${moment(fieldValue.selectDate).format("DD MMMM YYYY")}? Our team will review your request and contact you within 24 hours.`}</p>
            <div className="row" style={{ display: "flex", gap: "24px", width:"100%",paddingLeft:"10px" }}>
              <button
                className="hw-btn hw-btn--primaryOutline col-md-5 no-wrap"
                onClick={() => {
                  setShowWarningPopup(false);
                }}
              >
                Cancel
              </button>
              <button
                className="hw-btn hw-btn--primary col-md-6 no-wrap"
                onClick={async () => {
                  setShowWarningPopup(false);
                  const availability = await raiseInquiry(
                    data?.singleId,
                    moment(fieldValue.selectDate).format("YYYY-MM-DD"),
                    fieldValue?.numberOfChild,
                    fieldValue?.numberOfAdults,
                    Number(fieldValue?.numberOfChild) + Number(fieldValue?.numberOfAdults)
                  );
                }}
              >
                Yes, Raise an Enquiry
              </button>
            </div>
          </div>
        </WarningPopUp>
        <div className="hw-excursion--list">
          <div className="hw-excursion--listProduct">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <ImageGallery
                      items={images}
                      showFullscreenButton={true}
                      renderFullscreenButton={myFullscreenButton}
                      showPlayButton={images?.length > 1}
                      showThumbnails={images?.length > 1}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="hw-excursion--thubmGallery">
                      {Array(4)
                        .fill(1)
                        .map((_, i) => {
                          if (i === 3) {
                            return (
                              <div className="hw-excursion--thubmGalleryItem">
                                <img
                                  src={onlyImages?.[i]?.original}
                                  style={{ height: "100%", width: "100%" }}
                                />
                                {onlyImages?.length > 4 ? (
                                  <button
                                    className="hw-btn hw-btn--primary"
                                    onClick={() => {
                                      const elements =
                                        document.getElementsByClassName(
                                          "image-gallery-fullscreen-button"
                                        );
                                      if (elements?.[0]) {
                                        elements?.[0]?.click?.();
                                      }
                                    }}
                                  >
                                    <EmtyImageIcon />
                                    {`${onlyImages?.length - 1}+ Photos`}
                                  </button>
                                ) : null}
                              </div>
                            );
                          }
                          return (
                            <div className="hw-excursion--thubmGalleryItem empty-image">
                              {onlyImages?.[i]?.original ? (
                                <img
                                  src={onlyImages?.[i]?.original}
                                  style={{ height: "100%", width: "100%" }}
                                />
                              ) : (
                                <EmtyImageIcon />
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="hw-excursion--listProductData">
                  <div className="row">
                    <div className="col-12">
                      <h2 class="mb-0 h3">{data?.singleTitle}</h2>
                    </div>
                    <div className="col-12" style={{ display: "none" }}>
                      <div className="hw-price--dropdown hw-price--dropdownBorder">
                        <div
                          className="hw-excursion--dropdown"
                          onClick={() => {
                            setShowTypeDropdown(!showTypeDropdown);
                          }}
                        >
                          <CarIcon />
                          <span>
                            {data?.excursionTransfer?.[fieldValue?.transfer] ??
                              ""}
                          </span>
                          {!showTypeDropdown ? (
                            <ChevronDownIcon />
                          ) : (
                            <ChevronUpIcon />
                          )}
                        </div>
                        <div
                          className="hw-price--dropdownContent"
                          style={showTypeDropdown ? { display: "block" } : {}}
                        >
                          {Object.keys(data?.excursionTransfer ?? {})?.map(
                            (d) => {
                              return (
                                <div
                                  onClick={() => {
                                    setFieldValue({
                                      ...fieldValue,
                                      transfer: d,
                                    });
                                    setShowTypeDropdown(false);
                                  }}
                                >
                                  {data?.excursionTransfer?.[d]}
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`${data?.isDubaiPark ? 'col-md-5' : 'col-md-4 hw-datepicker--input'} `}>
                      <div style={{position:"relative"}}>
                      {data?.isDubaiPark ?
                          (
                              <span className="icon-text">
                               If you book the Dubai Park ticket, it will be valid for 90 days from the day you make the booking.
                              </span>
                          )
                          : <HwDatePicker
                              // isError={!fieldValue.selectDate}
                              selectDate={fieldValue.selectDate}
                              wrapperClassName="hw-date-range-picker-excursion"
                              onChangeFn={(date) => {
                                setAvailabilityMessage("")
                                setFieldValue({
                                  ...fieldValue,
                                  selectDate: date,
                                });
                                // Refresh prices for the newly selected date so a
                                // date-range price is honoured without re-loading detail.
                                resolvePricesForDate?.(date);
                              }}
                              type="Select Date"
                              showBlackoutAsX={true}
                              blackoutDates={
                                Array.isArray(
                                    data?.singleExcursionData
                                        ?.blackout_excursion_tour_date
                                )
                                    ? data?.singleExcursionData?.blackout_excursion_tour_date?.map?.(
                                    (d) => {
                                      return d?.excursion_blackout_date;
                                    }
                                    )
                                    : []
                              }
                              blackoutdays={blackOutDays}
                              renderType={"excursion"}
                          />}
                      {!fieldValue.selectDate ? (
                        // <p class="hw-p-error-cls mb-0">Please select date</p>
                        <div class="hw-input--error-search right">Please select date</div>
                      ) : null}
                      </div>
                    </div>
                    <div className="col-md-4 hw-person--roomInput">
                      <div
                        title={personLine}
                        style={{
                          position: "relative",
                        }}
                        className={`hw-input--input`}
                        onClick={(e) => {
                          setPersonsInfoModal(!personsInfoModal);
                          e.stopPropagation();
                        }}
                      >
                        <UserGroupIcon />
                        <span className="hw-text--hidden hw-text14 hw-text--muted">
                          Number of Person
                        </span>
                        <span className="hw-text--hidden hw-blue hw-fontBold">
                          {linePersons}
                          {personLine}
                        </span>
                        <span style={{position:'absolute',right:"10px"}}><ChevronDownIcon/></span>
                      </div>
                      <div className="paasenger-modal">
                        {/* commrmtntn */}
                        {personsInfoModal ? (
                          <PersonsInfoModal
                            hideInfants={isDahrTours || isHelidubai || isDubaiPark || isRayna}
                            values={fieldValue}
                            setFieldValue={(name, value) => {
                              setIsTicketAvailable(true);
                              setAvailabilityMessage("")
                              setFieldValue(prev => ({
                                ...prev,
                                [name]: value,
                              }));
                            }}
                            onClose={() => {
                              setPersonsInfoModal(false);
                            }}
                            data={data?.singleExcursionData}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className={`${data?.isDubaiPark ? 'col-md-3' : 'col-md-4'} `} >
                      <div className="hw-gp--btn">
                      {
                            !availability?.raiseInquiry ?
                        <button
                          className={`hw-btn hw-btn--primaryOutline hw-checkout-btn ${(!fieldValue?.selectDate || checkoutLoading) && "disabled"}`}
                          disabled={!fieldValue?.selectDate || checkoutLoading}
                          onClick={async() => {
                            setIsTicketAvailable(true);
                            // Direct-book products (no variations / slots): block a
                            // selected pax type priced at 0 (e.g. child price 0).
                            {
                              const hasVariationsOrSlots =
                                (data?.singleExcursionData?.excursion_variations?.length > 0) ||
                                (availability?.timeSlots?.length > 0) ||
                                (customTimeSlots?.length > 0);
                              if (!hasVariationsOrSlots) {
                                const tp = data?.excursionTaxPricing || {};
                                const priceOf = (k) => Number(tp?.[k]?.finalAmount ?? tp?.[k]?.baseAmount) || 0;
                                const blocked = [];
                                if ((fieldValue?.numberOfAdults ?? 0) > 0 && tp?.adult && !(priceOf("adult") > 0)) blocked.push("Adult");
                                if ((fieldValue?.numberOfChild ?? 0) > 0 && tp?.child && !(priceOf("child") > 0)) blocked.push("Child");
                                if (blocked.length) {
                                  setAvailabilityMessage(`${blocked.join(" and ")} seats are not available for this excursion.`);
                                  return;
                                }
                              }
                            }
                            if (data?.bookedAsPerTheCsvExpiryDate) {
                              const availability = await getAvailability(
                                data?.singleId,
                                moment(fieldValue.selectDate).format("YYYY-MM-DD"),
                                fieldValue?.numberOfChild,
                                fieldValue?.numberOfAdults
                              );
                              if(!availability?.success){
                                setAvailabilityMessage(availability?.message)
                                return;
                              }
                            }
                            if (isDahrTours) {
                              if (
                                (availableAdultSeat !== undefined &&
                                  fieldValue.numberOfAdults &&
                                  fieldValue.numberOfAdults >
                                    availableAdultSeat) ||
                                (availableChildSeat !== undefined &&
                                  fieldValue.numberOfChild &&
                                  fieldValue.numberOfChild > availableChildSeat)
                              ) {
                                setIsTicketAvailable(false);
                                return;
                              }
                            }

                                if (isHelidubai) {
                                  let totalPax = fieldValue?.numberOfAdults + fieldValue?.numberOfChild + fieldValue?.numberOfInfants
                                  if (totalPax > 5) {
                                    setAvailabilityMessage("Maximum 5 passengers allowed for this helicopter ride.")
                                    setShowVariations(false)
                                    return
                                  } else { setAvailabilityMessage("") }
                                }

                                if(availability?.timeSlots?.length > 0 || customTimeSlots?.length > 0){
                                  setShowVariations(true);
                                  return;
                                }

                                if (
                                  data?.singleExcursionData?.excursion_variations
                                    ?.length > 0
                                ) {
                                  setShowVariations(true);
                                } else if (availability?.excursionPrice && data?.bookedAsPerTheCsvExpiryDate && data?.bulkTicketInventorySystem){
                                  const url = `eId=${data?.singleId
                                    }&vId=${data?.singleId}&d=${moment(
                                      fieldValue.selectDate
                                    ).format("YYYY-MM-DD")}&t=${encodeURIComponent(
                                      moment(fieldValue.selectDate)
                                        .startOf("date")
                                        .format("YYYY-MM-DD HH:mm:ssZ")
                                    )}&tr=${fieldValue.transfer
                                    }&p=${`${fieldValue.numberOfAdults}n${fieldValue.numberOfChild}n${fieldValue.numberOfInfants}`}&eventId=${fieldValue?.time?.EventID
                                    }&pr=${pricingObj}&taxdata=${taxObj}&et=${encodeURIComponent(
                                        moment(fieldValue.selectDate)
                                          .endOf("date")
                                          .format("YYYY-MM-DD HH:mm:ssZ")
                                      )}`
                                      const session = await createCheckoutSession(url)
                                      if(session?.success){
                                        navigate(`/excursion/checkout?id=${session?.token}`)
                                      } else {
                                        setAvailabilityMessage("Failed to checkout. Please try again.")
                                      }
                                }
                                 else {
                                  if (
                                    !fieldValue.selectDate ||
                                    isAvailableTicketLessThanSelected
                                  ) {
                                    return;
                                  }
                                  const url = `eId=${data?.singleId
                                    }&vId=${data?.singleId}&d=${moment(
                                      fieldValue.selectDate
                                    ).format("YYYY-MM-DD")}&t=${encodeURIComponent(
                                      moment(fieldValue.selectDate)
                                        .startOf("date")
                                        .format("YYYY-MM-DD HH:mm:ssZ")
                                    )}&tr=${fieldValue.transfer
                                    }&p=${`${fieldValue.numberOfAdults}n${fieldValue.numberOfChild}n${fieldValue.numberOfInfants}`}&eventId=${fieldValue?.time?.EventID
                                    }&pr=${pricingObj}&taxdata=${taxObj}&et=${encodeURIComponent(
                                        moment(fieldValue.selectDate)
                                          .endOf("date")
                                          .format("YYYY-MM-DD HH:mm:ssZ")
                                      )}`;
                                  const session = await createCheckoutSession(url)
                                  if (session?.success) {
                                    navigate(`/excursion/checkout?id=${session?.token}`)
                                  } else {
                                    setAvailabilityMessage("Failed to checkout. Please try again.")
                                  }
                                }
                              }}
                            >
                                {checkoutLoading ? <span className="hw-spinner"></span> : (data?.singleExcursionData?.excursion_variations
                                  ?.length > 0 || availability?.timeSlots?.length > 0 || customTimeSlots?.length > 0)
                                  ? "Check Availability"
                                  : "Book now"}
                            </button> : <button
                              className={`hw-btn hw-btn--primaryOutline hw-checkout-btn raiseInquiryBtn`}
                                onClick={() => {
                                  setShowWarningPopup(true);
                                }}
                            >
                              Raise an Enquiry
                            </button>
                          }
                      </div>
                    </div>
                    {availabilityMessage && (
                      <p className="hw-p-error-cls mb-0">
                        {availabilityMessage}
                      </p>
                    )}
                    {!isTicketAvailable && isDahrTours ? (
                      <p className="hw-p-error-cls mb-0">
                        The number of selected tickets (
                        {totalSelectedTicketCount}) exceeds the available
                        tickets ({availableAdultSeat} Adults,{" "}
                        {availableChildSeat} Child). Please adjust your
                        selection.
                      </p>
                    ) : null}
                  </div>

                  {
                    data?.customProductTimeSlotBase && <div className="hw-excursion--note mt-12">
                    <InfoIcon/>
                    <span className="hw-fontBold">Note:</span> Price vary based on selected date and seat availability.
                  </div>
                  }

                  {
                      inquiry?.success ? (
                        <div className="hw-excursion--note seat-available">
                          You've successfully raised an enquiry for {Number(fieldValue?.numberOfAdults + fieldValue?.numberOfChild + fieldValue?.numberOfInfants)} tickets.
                        </div>
                      ) : availability?.raiseInquiry ? (
                        <div className="hw-excursion--note note-seat-available">
                          <ExcursionSeatIcon />
                          <span className="hw-fontBold">{Number(availability?.adultSeat ?? 0) + Number(availability?.childSeat ?? 0) + Number(availability?.infantSeat ?? 0)} seats available for {moment(fieldValue?.selectDate).format("DD MMMM YYYY")}</span> You've requested {fieldValue?.numberOfAdults + fieldValue?.numberOfChild + fieldValue?.numberOfInfants} tickets. Please raise an enquiry for group booking assistance.
                        </div>
                      ) : null
                    }

                  <div className="hw-excursion--listInfo row pb-0">
                    <div className="col-auto hw-excursion--listInfoList">
                      <span className="icon">
                        <InstantIconNew/>
                      </span>
                      <span className="icon-text">
                        <b>Instant Confirmation</b>

                        {data?.singleExcursionData
                          ?.excursion_instant_confirmation === "Yes" || true
                          ? "Available"
                          : "NA"}
                      </span>
                    </div>
                    {data?.singleExcursionData?.excursion_free_cancellation ? (
                      <div className="col-auto hw-excursion--listInfoList">
                        <span className="icon">
                          <TickIcon />
                        </span>
                        <span className="icon-text">
                          <b>Free Cancellation:</b>

                          {data?.singleExcursionData
                            ?.excursion_free_cancellation || "-"}
                        </span>
                      </div>
                    ) : null}
                    {data?.singleExcursionData?.excursion_duration ? (
                      <div className="col-auto hw-excursion--listInfoList">
                        <span className="icon">
                          <TimeIcon />
                        </span>
                        <span className="icon-text">
                          <b>Duration:</b>
                          {data?.singleExcursionData?.excursion_duration}
                        </span>
                      </div>
                    ) : null}

                    {data?.singleExcursionData?.excursion_mealse ? (
                      <div className="col-auto hw-excursion--listInfoList">
                        <span className="icon">
                          <MealIcon />
                        </span>
                        <span className="icon-text">
                          <b>Meals:</b>
                          {data?.singleExcursionData?.excursion_mealse}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {checkAvailability ? <div className="hw-main--loaderCommon" /> : null}
            {
              showVariations && <div className="hw-excursion--listProductSelect">
                <h3 className="h4 mb-0 hw-mt--20">Availability</h3>
                <div
                  className="hw-excursion--selectSlider hw-mt--10"
                  style={{ width: "100%" }}
                >
                  <VariationSlider
                    selectedDate={fieldValue.selectDate}
                    data={data}
                    fieldValue={fieldValue}
                    setFieldValue={setFieldValue}
                    isAvailableTicketLessThanSelected={
                      isAvailableTicketLessThanSelected
                    }
                    totalSelectedTicketCount={totalSelectedTicketCount}
                    variations={
                      data?.singleExcursionData?.excursion_variations ?? []
                    }
                    customProductTimeSlot={availability}
                  />
                </div>
              </div>
            }
          {/* <div className="hw-excursion--listProductSelect">
            <h3 className="h4 mb-0 hw-mt--20">Availability</h3>
            <div
              className="hw-excursion--selectSlider hw-mt--10"
              style={{ width: "100%" }}
            >
              {showVariations ? (
                <VariationSlider
                  selectedDate={fieldValue.selectDate}
                  data={data}
                  fieldValue={fieldValue}
                  setFieldValue={setFieldValue}
                  isAvailableTicketLessThanSelected={
                    isAvailableTicketLessThanSelected
                  }
                  totalSelectedTicketCount={totalSelectedTicketCount}
                  variations={
                    data?.singleExcursionData?.excursion_variations ?? []
                  }
                />
              ) : null}
            </div>
          </div> */}

          <div className="hw-tab--scroll mt-4">
            <div className="hw-tab--scroll__list">
              {data?.singleExcursionData?.excursion_ticket_highlights ? (
                <div
                  className={`hw-scroll--listItem ${activeTab === "excursion_ticket_highlights" ? " active": ""}`}
                  onClick={() => {
                    scrollToDiv("excursion_ticket_highlights");
                  }}
                >
                  Key Highlights
                </div>
              ) : null}
              {data?.singleExcursionData?.excursion_ticket_inclusions ? (
                <div
                  className={`hw-scroll--listItem ${activeTab === "excursion_ticket_inclusions" ? " active": ""}`}
                  onClick={() => {
                    scrollToDiv("excursion_ticket_inclusions");
                  }}
                >
                  Inclusions
                </div>
              ) : null}
              {data?.singleExcursionData?.excursion_ticket_exclusions ? (
                <div
                  className={`hw-scroll--listItem ${activeTab === "excursion_ticket_exclusions" ? " active": ""}`}
                  onClick={() => {
                    scrollToDiv("excursion_ticket_exclusions");
                  }}
                >
                  Exclusions
                </div>
              ) : null}
              {data?.singleExcursionData
                ?.excursion_ticket_cancellation_policy ? (
                <div
                  className={`hw-scroll--listItem ${activeTab === "excursion_ticket_cancellation_policy" ? " active": ""}`}
                  onClick={() => {
                    scrollToDiv("excursion_ticket_cancellation_policy");
                  }}
                >
                  Cancellation policy
                </div>
              ) : null}
            </div>
            <div className="hw-scroll--content">
              <div className="hw-scroll--contentList">
                <ToggleItems data={data} />
              </div>
              <div className="hw-stay--stick">
                <h3 class="mb-0 h4">Why Dahr Tours?</h3>
                <ul className="unlist">
                  <li>
                    <TickIcon />
                    <span>Trusted by 500+ active B2B agents</span>
                  </li>
                  <li>
                    <TickIcon />
                    <span>Instant booking confirmation</span>
                  </li>
                  {/* <li>
                    <TickIcon />
                    <span>Bulk ticket download in a single PDF</span>
                  </li> */}
                  <li>
                    <TickIcon />
                    <span>24/7 Live Chat Support</span>
                  </li>
                  <li>
                    <TickIcon />
                    <span>Access exclusive B2B rates</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default ExcursionDetails;
